import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PolicyHelper, PolicyNetworkLayer } from "helpers";
import { getUser, getActivePolicy } from "globals/auth";
import { getMotorPolicyQuestionsAndResponses } from "globals/renewal";
import { setLoading } from "globals/overlays";
import { getPaymentType } from "globals/auth";


function NoteSubmissionHook() {

    const [error, setError] = useState("");
    const user = useSelector(getUser);
    const policy = useSelector(getActivePolicy);
    const selectedPaymentPlan = useSelector(getPaymentType);
    const savedRenewalQuestionsAndAnswers = useSelector(getMotorPolicyQuestionsAndResponses);
    const isHomePolicy = policy?.department_class === "Fire";
    const dispatch = useDispatch();

    useEffect(() => {
    }, [dispatch]);

    async function consentToComprehensiveValueAgreement(newlyRewrittenPolicy) {
        const agreement = `I, ${user.first_name} ${user.last_name}, do hereby agree that in the absence of the required valuation report and in the event of a loss, the claim settlement will be based on the PRE-ACCIDENT MARKET VALUE of the motor vehicle or the ESTIMATE OF VALUE, whichever is less.`;
        let response = await PolicyNetworkLayer.sendComprehensiveAgreementNote(user, newlyRewrittenPolicy, agreement);
        if (!response.success) throw new Error("Unable to update Comprehensive Value Agreement");
    }

    async function consentToVehicleValueAgreement(newlyRewrittenPolicy) {
        let verbage = `Policy Holder: ${user.first_name} ${user.last_name} \nPolicy Number: ${newlyRewrittenPolicy?.policy_number} \n`;
        const numberOfVehicles = newlyRewrittenPolicy?.risks?.length || 0;
        if (numberOfVehicles === 0)
            return;
        for (let i = 0; i < numberOfVehicles; i++) {
            verbage = verbage + `Vehicle Make:  ${newlyRewrittenPolicy?.risks[i]?.make} \n`;
            verbage = verbage + `Vehicle Model:  ${newlyRewrittenPolicy?.risks[i]?.model} \n`;
            verbage = verbage + `Vehicle Chassis:  ${newlyRewrittenPolicy?.risks[i]?.chassis_number} \n`;
            verbage = verbage + `Sum Insured:  ${newlyRewrittenPolicy?.risks[i]?.renewal_sum_insured} \n`;
        }
        verbage =
            verbage +
            "We recommend that you do a Valuation Report each year. However, in the absence of receiving one, we will maintain your Sum Insured for this policy period. \n";
        verbage =
            verbage +
            "NB: In the event of the claim, the basis of the settlement will be the pre-accident value (as determined by a Motor Vehicle Assessor) or the Sum Insured, whichever is less. \n";
        verbage = verbage + "Please indicate your agreement to maintain your Sum Insured";

        let response = await PolicyNetworkLayer.sendValueDeclarationNote(user, newlyRewrittenPolicy, verbage);

        if (!response.success) throw new Error("Unable to update Vehicle Value Agreement");
    }


    async function handleRenewalQuestionNoteSubmission(newlyRewrittenPolicy) {
        let note = "The following renewal question answers were given in the customers attempt to renew this policy:\n\n";
        savedRenewalQuestionsAndAnswers.forEach(element => {
            note = note + element.question + " - ANSWER : " + (element.answer === true ? "YES" : "NO") + "\n\n";
        });

        // let uid = `${config.branch_name} ${user.national_id} ${policy.policy_prefix} ${policy.policy_number}`;

        // Send a note
        const response = await PolicyNetworkLayer.storeRenewalQuestions({
            link_to: "policy",
            //TODO: change policy_id to be one from the new policy created
            link_id: newlyRewrittenPolicy?.policy_id,
            description: "Renewal Questions",
            notes: note,
            type: "Note For File",
            alert: false,
        });

        if (!response.success) {
            // do somethig here
            dispatch(setLoading(false));
            setError(response.error_message);
            throw new Error(`There was an error moving forward with your Renewal. ${response.error_message}`);
        }
    }

    async function handleVehicleValueAgreement(newlyRewrittenPolicy) {

        try {

            if (!newlyRewrittenPolicy?.is_third_party_policy && !isHomePolicy) {
                if (PolicyHelper.isComprehensiveAgreedValue(newlyRewrittenPolicy.policy_prefix)) {
                    await consentToComprehensiveValueAgreement(newlyRewrittenPolicy);
                } else {
                    await consentToVehicleValueAgreement(newlyRewrittenPolicy);
                }
            }
        }
        catch (e) {
            dispatch(setLoading(false));
            setError(e.message);
            throw new Error(e.message);
        }

    }

    async function handlePaymentAgreementNoteSubmission(newlyRewrittenPolicy) {

        try {
            const response = await PolicyNetworkLayer.sendPaymentAgreementNote(newlyRewrittenPolicy, user, selectedPaymentPlan);
            if (!response.success) {
                dispatch(setLoading(false));
                setError(response.error_message);
                throw new Error(`Payment agreement failed. ${response.error_message}`);
            }
        }
        catch (e) {
            dispatch(setLoading(false));
            setError(e.message);
            throw new Error(e.message);
        }
    }


    async function handleNoteSubmission(newlyRewrittenPolicy) {
        try {
            await handleVehicleValueAgreement(newlyRewrittenPolicy);
            await handleRenewalQuestionNoteSubmission(newlyRewrittenPolicy);
            await handlePaymentAgreementNoteSubmission(newlyRewrittenPolicy);
        } catch (e) {
            dispatch(setLoading(false)); 
            setError(e.message);
            throw new Error(e.message);
        }
    }

    return{
        handleNoteSubmission,
    }
}

export {
    NoteSubmissionHook
};